export const SM_WIDTH = 360;
export const MD_WIDTH = 768;
export const LG_WIDTH = 1080;
export const XL_WIDTH = 1440;
export const mailReg = /^(([^<>(){|}[\]\\.,;:`~'!?№&%?*+=#\s@"]+(\.[^<>(){|}[\]\\.,;:`~'!?№&%?*+=#\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const path = process.env.NODE_ENV === "production" ? "/assets/" : "./";
export const numberReg = /^-?\d*\.?\d*$/;
export const PAYLOAD_TYPE_FORMDATA = "formdata";
export const PAYLOAD_TYPE_JSON = "json";
export const RESPONSE_TYPE_JSON = "json";